import { ClientRegistrationApiRepository } from "@/app/infrastructures/repositories/api/ClientRegistrationApiRepository";
import { ManagingCountryOption } from "@/data/persistences/repositories/contracts/ClientRegistrationRepositoryInterface";
import {
  ClientRegistrationEntities,
  ClientRegistrationDetail
} from "@/domain/entities/ClientRegistration";
import { injectable } from "tsyringe";
import {
  ClientRegistrationRequest,
  ClientRegistrationApproveRejectRequest,
  EditClientRegistrationRequest,
  CreateClientBranchRequest,
  EditRenewRatesRequest,
  EditInsuranceRateRequest
} from "@/data/payload/contracts/ClientRegistrationRequest";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
import { EditClientManagementBasicInformationRequest } from "@/data/payload/api/ClientManagementApiRequest";
import {
  AbortUploadRateApiRequest,
  ClientRateHistoryApiRequest,
  EditClientRegistrationApiRequestV2
} from "@/data/payload/api/ClientRegistrationApiRequest";

@injectable()
export class ClientRegistrationPresenter {
  private repository: ClientRegistrationApiRepository;

  constructor(repository: ClientRegistrationApiRepository) {
    this.repository = repository;
  }

  public getListClientRegistration(
    page: number,
    limit: number,
    search: string,
    status: string,
    type: string,
    isTotalData: boolean,
    orderBy = "",
    sortDirection = ""
  ): Promise<ClientRegistrationEntities> {
    return this.repository.getListClientRegistration(
      page,
      limit,
      search,
      status,
      type,
      isTotalData,
      orderBy,
      sortDirection
    );
  }

  public createClientBranchRegistration(
    payload: CreateClientBranchRequest
  ): Promise<ResponsePayload> {
    return this.repository.createClientBranch(payload);
  }

  public getDetailClientRegistration(
    id: number
  ): Promise<ClientRegistrationDetail> {
    return this.repository.getDetailClientRegistration(id);
  }

  public addClientRegistration(
    payload: ClientRegistrationRequest,
    version = "v1"
  ): Promise<ResponsePayload> {
    return this.repository.addClientRegistration(payload, version);
  }

  public editClientManagemetBasicInformation(
    payload: EditClientManagementBasicInformationRequest,
    version = "v1"
  ): Promise<ResponsePayload> {
    return this.repository.editClientManagemetBasicInformation(
      payload,
      version
    );
  }

  public approveClientRegistration(
    payload: ClientRegistrationApproveRejectRequest
  ): Promise<ResponsePayload> {
    return this.repository.approveClientRegistration(payload);
  }

  public rejectClientRegistration(
    payload: ClientRegistrationApproveRejectRequest
  ): Promise<ResponsePayload> {
    return this.repository.rejectClientRegistration(payload);
  }

  public editClientRegistration(
    payload: EditClientRegistrationRequest
  ): Promise<ResponsePayload> {
    return this.repository.editClientRegistration(payload);
  }

  public editRenewRates(
    payload: EditRenewRatesRequest
  ): Promise<ResponsePayload> {
    return this.repository.editRenewRates(payload);
  }

  public editClientRegistrationV2(
    payload: EditClientRegistrationApiRequestV2
  ): Promise<ResponsePayload> {
    return this.repository.editClientRegistrationV2(payload);
  }

  public getDetailClientRegistrationV2(
    id: number
  ): Promise<ClientRegistrationDetail> {
    return this.repository.getDetailClientRegistrationV2(id);
  }

  public editClientParentV2(
    payload: EditClientRegistrationApiRequestV2
  ): Promise<ResponsePayload> {
    return this.repository.editClientParentV2(payload);
  }

  public editClientInsuranceRate(
    payload: EditInsuranceRateRequest
  ): Promise<ResponsePayload> {
    return this.repository.editClientInsuranceRate(payload);
  }

  public abortUploadRate(payload: AbortUploadRateApiRequest) {
    return this.repository.abortUploadRate(payload);
  }

  public async getClientRateHistory(params: ClientRateHistoryApiRequest) {
    return this.repository.getClientRateHistory(params);
  }

  public downloadAttachment(clientId: number): Promise<ResponsePayload> {
    return this.repository.downloadAttachment(clientId);
  }

  public getManagingCountry(): Promise<ManagingCountryOption[]> {
    return this.repository.getManagingCountry();
  }
}
